<template>
    <v-card elevation="6" class="base-card-container pa-5 mt-4">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <!--Movimientos Tramite-->
            <v-col cols="12" md="12">
                <tramitesButtons :tramitesOptions="tramitesOptions" @reload="reload"></tramitesButtons>
            </v-col>
            <!--Movimientos-->
            <v-col cols="12" md="12">
                <Movimientos></Movimientos>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Movimientos from "@/components/pages/General/Movimientos/VerMovimientos.vue";
import tramitesButtons from "@/components/pages/Shared/components/tramites-buttons.vue";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: { Movimientos, tramitesButtons },
    data: function () {
        return {
            showcargando: true,
            tramitesOptions: [],
            reporteInfo: null,
        }
    },
    async mounted() {
        this.showcargando = false;
        this.changeReporteMenuOption('Movimientos');
        let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.reporteInfo = datos;
        datos.urlname = this.$route.name;
        await this.ObtenerTramitesOptions();
        await MetodosGenerales.guardarEnSesionInfoReporte(datos, "reporte");
        let encabezado = await reporteExpJur.EncabezadoReporte(this);
        let validaConc = await MetodosGenerales.getReporteEstatus(this);
        if (encabezado.fhtermino.length == undefined && validaConc == 1) {
            this.$swal({
                position: 'center',
                icon: 'warning',
                title: 'Atención',
                html: 'No se pueden agregar movimientos si no hay fecha de término capturada',
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Aceptar',
                showCancelButton: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                }
            });
        }
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        reload(val) {
            this.$emit("ReloadEncabezado");
        },
        async ObtenerTramitesOptions() {
            let response = await reporteExpJur.ObtenerOpcionesTramites(this.reporteInfo);
            this.tramitesOptions = response;
            //this.setLoading = this.setLoading + 1;
        },
    }
}
</script>